




import {
  Vue,
  Component,
} from "@/shared/vuepack";


import TermsFeeSchedule from "@/employee/components/onboarding/TermsFeeSchedule.vue";
import AvidiaTermsFeeSchedule from "@/employee/components/onboarding/AvidiaTermsFeeSchedule.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    TermsFeeSchedule,
    AvidiaTermsFeeSchedule
  }
})
export default class PrintTermsFeeSchedule extends Vue {
  custodianSettingStore = useCustodianSettingsStore();
}
